import api from "./api";

const stockTransferService = {

  save: async (data) => {
    const res = await api.post("/stockTransfer/save", data);
    return res.data;
  },

  // getAll: async (companyId) => {
  //   const res = await api.get(`/stockTransfer/getAll/${companyId}`);
  //   return res.data;
  // },

  getAll: async (companyId, employeeId, roleId, page, limit, search, status, toCompanyId) => {
    const res = await api.get(
      `/stockTransfer/getAll/${companyId}/${employeeId}/${roleId}`, {
      params: {
        page,
        limit,
        search,
        status,
        toCompanyId
      }
    }
    );
    return res.data;
  },

  update: async (id, data) => {
    const res = await api.put(`/stockTransfer/update/${id}`, data);
    return res.data;
  },


  getById: async (id) => {
    const res = await api.get(`/stockTransfer/getById/${id}`);
    return res.data;
  },

  updateStatus: async (id) => {
    const res = await api.put(`/stockTransfer/updatestatus/${id}`);
    return res.data;
  },

  // ✅ ADD THIS
  getAvailableStock: (companyId, projectId, storeId, itemId) =>
    api.get(
      `/stockTransfer/available-stock/${companyId}/${projectId}/${storeId}/${itemId}`
    ),

  getVoucherNo: (projectId, storeId) =>
    api.get(`/stocktransfer/generate-voucher/${projectId}/${storeId}`),

  cancelTransfer: async (id, data) => {
    const res = await api.put(`/stockTransfer/cancel/${id}`, data);
    return res.data;
  },

  getInTransit: async (companyId, page, limit, search, status, fromCompanyId) => {
    const res = await api.get(`/stockTransfer/intransit/${companyId}`, {
      params: { page, limit, search, status, fromCompanyId }
    });
    return res.data;
  },

  receiveTransfer: async (id, data) => {
    const res = await api.put(`/stockTransfer/receive/${id}`, data);
    return res.data;
  },

  rejectTransfer: async (id, data) => {
    const res = await api.put(`/stockTransfer/reject/${id}`, data);
    return res.data;
  },

};

export default stockTransferService;
